import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PrimaryButton } from "../../globalComponents";
import { useAuth } from "../../context/auth.context";
import { useWhitelabel } from "../../context/whitelabel.context";
import { clearStoredAuthData } from "../../utils/authStorage";

const VerificationPending = () => {
    const navigate = useNavigate()
    const { RequestVerification, setAuthStatus, setVerifiedUser, setIsAdmin, ClearAdminAccessMode } = useAuth()
    const { logoVertical, linkCadastro } = useWhitelabel()
    const affiliateName = (localStorage.getItem('@Subdominio:BetBuilder') || 'afiliado').trim()

    const [currentStep, setCurrentStep] = useState(1)
    const [selectedFile, setSelectedFile] = useState(null)
    const [isSending, setIsSending] = useState(false)
    const [feedback, setFeedback] = useState('')
    const [error, setError] = useState('')

    const handleFileChange = (event) => {
        const file = event.target.files?.[0]
        setSelectedFile(file || null)
        setError('')
        setFeedback('')
    }

    const handleSubmit = async () => {
        if (!selectedFile) {
            setError('Selecione uma imagem para enviar.')
            return
        }

        setIsSending(true)
        setError('')
        setFeedback('')

        try {
            await RequestVerification(selectedFile)
            setFeedback('Solicitacao enviada com sucesso. Aguarde a aprovacao para liberar o acesso.')
        } catch (err) {
            const responseData = err?.response?.data
            const errorCode = responseData?.error?.code || responseData?.code
            const errorMessage = responseData?.error?.message || responseData?.message

            if (errorCode === 'AUTH_VERIFICATION_ALREADY_PENDING') {
                setFeedback(errorMessage || 'Ja existe uma solicitacao pendente. Aguarde a aprovacao para liberar o acesso.')
                return
            }

            setError(errorMessage || 'Nao foi possivel enviar a solicitacao de verificacao.')
        } finally {
            setIsSending(false)
        }
    }

    const handleLogout = () => {
        clearStoredAuthData()
        sessionStorage.removeItem('@Token:BetBuilder')
        localStorage.removeItem('@Email:BetBuilder')
        localStorage.removeItem('@Nome:BetBuilder')
        localStorage.removeItem('@Telefone:BetBuilder')
        localStorage.removeItem('saldo')
        localStorage.removeItem('horarioLogin')

        setAuthStatus(false)
        setVerifiedUser(null)
        setIsAdmin(false)
        ClearAdminAccessMode()
        navigate('/Login')
    }

    return (
        <div style={{
            minHeight: '100vh',
            width: '100%',
            background: 'linear-gradient(130deg, #090909 0%, #111111 45%, #1b1b1b 100%)',
            color: '#fff',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 20
        }}>
            <div style={{
                width: '100%',
                maxWidth: 520,
                border: '1px solid #2f2f2f',
                borderRadius: 16,
                padding: 24,
                backgroundColor: '#0f0f0f',
                boxShadow: '0 20px 40px rgba(0,0,0,0.35)',
                display: 'flex',
                flexDirection: 'column',
                gap: 16
            }}>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <img src={logoVertical} alt="Logo" style={{ maxWidth: 140, maxHeight: 140, width: '100%', height: '100%', objectFit: 'contain' }} />
                </div>

                <span style={{ color: '#bdbdbd', fontSize: 13 }}>Passo {currentStep} de 2</span>

                {currentStep === 1 && (
                    <>
                        <h1 style={{ fontSize: 28, margin: 0 }}>Parabens! Voce esta a um passo para receber as melhores dicas para sua BET!</h1>
                        <p style={{ margin: 0, color: '#d0d0d0' }}>
                            Para finalizar, crie uma conta no site:
                        </p>

                        <button
                            type="button"
                            onClick={() => {
                                if (linkCadastro) {
                                    window.open(linkCadastro, '_blank', 'noopener,noreferrer')
                                }
                            }}
                            disabled={!linkCadastro}
                            style={{
                                height: 40,
                                borderRadius: 48,
                                border: '1px solid #3f3f3f',
                                backgroundColor: 'transparent',
                                color: '#78b7ff',
                                cursor: linkCadastro ? 'pointer' : 'not-allowed',
                                fontWeight: 600
                            }}
                        >
                            {linkCadastro ? 'Criar conta no site' : 'Carregando link de cadastro...'}
                        </button>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                            <PrimaryButton onClick={() => setCurrentStep(2)}>
                                Ja criei minha conta, continuar
                            </PrimaryButton>

                            <button
                                onClick={handleLogout}
                                style={{
                                    height: 40,
                                    borderRadius: 48,
                                    border: '1px solid #3f3f3f',
                                    backgroundColor: 'transparent',
                                    color: '#d7d7d7',
                                    cursor: 'pointer'
                                }}
                            >
                                Sair
                            </button>
                        </div>
                    </>
                )}

                {currentStep === 2 && (
                    <>
                        <h1 style={{ fontSize: 28, margin: 0 }}>Verificacao de cadastro</h1>
                        <p style={{ margin: 0, color: '#d0d0d0' }}>
                            Seu usuario ainda nao foi verificado. Para continuar, envie uma imagem comprovando o cadastro no site {affiliateName}.
                        </p>
                        <p style={{ margin: 0, color: '#ffd27a' }}>
                            Se voce ja enviou sua imagem antes, basta aguardar a avaliação da nossa equipe.
                        </p>

                        <input
                            type="file"
                            accept="image/png,image/jpeg,image/jpg,image/webp"
                            onChange={handleFileChange}
                            style={{
                                backgroundColor: '#1a1a1a',
                                border: '1px solid #323232',
                                borderRadius: 8,
                                color: '#fff',
                                padding: 10
                            }}
                        />

                        {selectedFile && <span style={{ color: '#bdbdbd' }}>Arquivo: {selectedFile.name}</span>}
                        {error && <span style={{ color: '#ff7c7c' }}>{error}</span>}
                        {feedback && <span style={{ color: '#8fffb2' }}>{feedback}</span>}

                        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                            <PrimaryButton onClick={handleSubmit} disabled={isSending} style={{ opacity: isSending ? 0.6 : 1 }}>
                                {isSending ? 'Enviando...' : 'Enviar verificacao'}
                            </PrimaryButton>

                            <button
                                onClick={handleLogout}
                                style={{
                                    height: 40,
                                    borderRadius: 48,
                                    border: '1px solid #3f3f3f',
                                    backgroundColor: 'transparent',
                                    color: '#d7d7d7',
                                    cursor: 'pointer'
                                }}
                            >
                                Sair
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}

export default VerificationPending
